import Vue from "vue";
import httpService from "../../components/service";
export const filters = {
    namespaced: true,
    state: {
        filters: {},
        size: {},
        clients: {},
        status: null
    },
    getters: {
        getLength: (state, getters) => seg => {
            return Vue._.size(state.filters[seg]);
        },
        getFilters: (state, getters) => seg => {
            return state.filters;
        },
        getSize: (state, getters) => seg => {
            return state.size;
        }
    },
    mutations: {
        POPULATE_FILTERS(state, data) {
            state.filters = data;
        },
        POPULATE_SIZE(state, data) {
            state.size = data;
        }
    },
    actions: {
        populate: (context, data) => {
            return new Promise((resolve, reject) => {
                let queryString = "?";
                Vue._.forEach(data.routeParams, function(param, key) {
                    if (queryString !== "?") {
                        queryString += "&";
                    }
                    if (key === "status" && param === "") {
                        queryString += "";
                    } else {
                        queryString += key + "=" + param;
                    }
                });
                httpService.get("/plano/status" + queryString).then(function(datas) {
                    context.commit("POPULATE_FILTERS", datas);
                    resolve();
                });
            });
        },
        getSize: (context, data) => {
            return new Promise((resolve, reject) => {
                httpService.get("/plano/size").then(function(response) {
                    context.commit("POPULATE_SIZE", response);
                    resolve();
                });
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/planos/filters.js